/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S7_P2_BInputs */

const tr_mesafeli_s7_p2_b = /** @type {(inputs: Mesafeli_S7_P2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. ShopPanel, ödemenin alınmasıyla Müşteri'nin onayı doğrultusunda ifasına başlanan ve seçilen dönem boyunca sürekli olarak sunulan bir hizmettir; bu Sözleşme bakımından uygulanacak istisna yalnızca Madde 15/1-h'dir.`)
};

const en_mesafeli_s7_p2_b = /** @type {(inputs: Mesafeli_S7_P2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. ShopPanel is a service whose performance begins upon receipt of payment in line with the Customer's consent and which is provided continuously throughout the selected period; the only exception applicable to this Agreement is Article 15/1-h.`)
};

const de_mesafeli_s7_p2_b = /** @type {(inputs: Mesafeli_S7_P2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. ShopPanel ist ein Dienst, dessen Erbringung mit Eingang der Zahlung aufgrund der Zustimmung des Kunden beginnt und der während des gewählten Zeitraums fortlaufend erbracht wird; für diesen Vertrag ist allein die Ausnahme nach Artikel 15/1-h anwendbar.`)
};

const ru_mesafeli_s7_p2_b = /** @type {(inputs: Mesafeli_S7_P2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. ShopPanel — услуга, оказание которой начинается с получением оплаты в соответствии с согласием Клиента и которая оказывается непрерывно в течение выбранного периода; единственным исключением, применимым к настоящему Договору, является статья 15/1-h.`)
};

/**
* | output |
* | --- |
* | ". ShopPanel is a service whose performance begins upon receipt of payment in line with the Customer's consent and which is provided continuously throughout t..." |
*
* @param {Mesafeli_S7_P2_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s7_p2_b = /** @type {((inputs?: Mesafeli_S7_P2_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S7_P2_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s7_p2_b(inputs)
	if (locale === "de") return de_mesafeli_s7_p2_b(inputs)
	if (locale === "ru") return ru_mesafeli_s7_p2_b(inputs)
	return tr_mesafeli_s7_p2_b(inputs)
});